import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { siteInfo } from "@/mocks/siteInfo";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "每日黑料是什么网站？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "每日黑料是一个专注于中文互联网娱乐八卦和网红资讯的内容平台。我们每日更新最新的网红塌房、吃瓜爆料、明星八卦等热点内容，是中文互联网最大的吃瓜社区之一。",
      },
    },
    {
      "@type": "Question",
      name: "每日黑料大赛入口在哪里？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "每日黑料大赛入口位于网站导航栏的「每日黑料大赛」栏目，点击即可进入。每期大赛由网友投票选出「月度塌房之王」，参与投票完全免费。",
      },
    },
    {
      "@type": "Question",
      name: "每日黑料吃瓜网最新地址是什么？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "每日黑料吃瓜网最新官方地址为 http://tukedty.cn/，建议收藏此网址以便随时访问。所有最新爆料和吃瓜内容均在此地址第一时间更新。",
      },
    },
    {
      "@type": "Question",
      name: "如何向每日黑料投稿爆料？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "您可以通过发送邮件至 hello@tukedty.cn 向我们投稿爆料。我们会对每一条爆料进行核实，确保内容真实性后再进行发布。投稿人信息将严格保密。",
      },
    },
    {
      "@type": "Question",
      name: "每日黑料的内容是否真实可靠？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们坚持对每一条爆料进行多方核实。编辑团队由资深娱评人和调查记者组成，所有发布的爆料内容均经过严格的真实性审核流程，确保为读者提供可靠的信息。",
      },
    },
    {
      "@type": "Question",
      name: "如何参与每日黑料大赛投票？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "进入每日黑料大赛页面后，您可以看到本期候选人名单。每位用户每天有3次投票机会，可以投给不同的候选人，也可以全部投给同一位。投票完全免费，无需注册登录。",
      },
    },
  ],
};

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: `关于我们 - ${siteInfo.name}`,
  description: siteInfo.description,
  url: `${siteInfo.url}/about`,
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <Navbar />

      <main>
        <div className="pt-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center mb-14">
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
                关于每日黑料
              </h1>
              <p className="text-base text-foreground-600 leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-eye-line text-primary-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <p className="text-3xl font-heading font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {(siteInfo.stats.dailyVisitors / 10000).toFixed(0)}万+
                  </p>
                  <p className="text-sm text-foreground-500 whitespace-nowrap">日均访客</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-file-text-line text-accent-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <p className="text-3xl font-heading font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {(siteInfo.stats.totalArticles / 10000).toFixed(1)}万+
                  </p>
                  <p className="text-sm text-foreground-500 whitespace-nowrap">累计爆料</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-user-smile-line text-secondary-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <p className="text-3xl font-heading font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {(siteInfo.stats.registeredUsers / 10000).toFixed(0)}万+
                  </p>
                  <p className="text-sm text-foreground-500 whitespace-nowrap">注册用户</p>
                </div>
              </div>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                品牌介绍
              </h2>
              <div className="prose prose-lg max-w-none text-foreground-700 leading-relaxed">
                <p>
                  每日黑料成立于{siteInfo.foundedYear}年，是中文互联网领先的娱乐八卦与网红资讯平台。我们致力于为用户提供<strong>最新、最全、最真实</strong>的网红塌房、吃瓜爆料和娱乐圈资讯。
                </p>
                <p>
                  作为每日黑料大赛的主办方，我们首创了「月度塌房之王」评选机制，让广大吃瓜群众能够参与到热点事件的评选中来。每日黑料大赛入口自上线以来，已累计吸引超过千万用户参与投票。
                </p>
                <p>
                  每日黑料吃瓜网一直坚持<strong>内容为王</strong>的理念。我们的编辑团队由资深娱评人、前媒体记者和互联网调查员组成，每一条爆料都经过严格的事实核查和多方验证，确保为用户提供真实可靠的吃瓜内容。
                </p>
                <p>
                  无论是网红塌房现场直击、黑料每日爆料，还是明星八卦最新动态，每日黑料都是您最值得信赖的信息来源。我们不仅是吃瓜内容的传播者，更是互联网真相的守护者。
                </p>
              </div>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                口碑评价
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "每日黑料现在是我每天的必刷网站，吃瓜内容更新速度超快，而且信息很靠谱，不像有些网站全是谣言。每日黑料大赛我每期都投！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 资深吃瓜群众 · 小美</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "作为自媒体人，每日黑料的深度报道给了我很多选题灵感。他们不光爆料，还会做深度分析，这在吃瓜类网站里真的很难得。"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 自媒体博主 · 老K</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "每日黑料大赛这个形式太有意思了，把吃瓜变成了一种互动体验。现在我和朋友们每天讨论的就是今天该把票投给谁。"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 大学生 · 小明</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "看了这么多吃瓜网站，每日黑料的文章质量是最高的。编辑的文笔也很好，读起来很舒服。每日黑料吃瓜网最新地址已收藏！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 互联网从业者 · Alex</p>
                </div>
              </div>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                商务合作
              </h2>
              <div className="rounded-2xl bg-accent-50 border border-accent-200/50 p-6 md:p-8">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  每日黑料欢迎各类商务合作洽谈，包括但不限于品牌广告投放、软文推广、内容共创、活动联合等合作形式。我们拥有<span className="font-bold text-foreground-900">日均128万活跃用户</span>，覆盖18-35岁核心消费群体，是品牌触达年轻用户的最佳渠道之一。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
                  <div className="bg-background-50 rounded-lg p-4 text-center border border-background-200/70">
                    <i className="ri-advertisement-line text-accent-500 text-xl w-6 h-6 flex items-center justify-center mx-auto mb-2"></i>
                    <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">广告投放</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">hello@tukedty.cn</p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-4 text-center border border-background-200/70">
                    <i className="ri-shake-hands-line text-accent-500 text-xl w-6 h-6 flex items-center justify-center mx-auto mb-2"></i>
                    <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">内容合作</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">hello@tukedty.cn</p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-4 text-center border border-background-200/70">
                    <i className="ri-briefcase-line text-accent-500 text-xl w-6 h-6 flex items-center justify-center mx-auto mb-2"></i>
                    <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">媒体采访</p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">hello@tukedty.cn</p>
                  </div>
                </div>
                <p className="text-xs text-foreground-500 mt-6 text-center">
                  工作日 9:00 - 18:00，我们会在24小时内回复您的合作需求
                </p>
              </div>
            </div>

            <div className="max-w-3xl mx-auto mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                联系方式
              </h2>
              <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">电子邮箱</p>
                      <p className="text-sm text-foreground-600 whitespace-nowrap">{siteInfo.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">联系电话</p>
                      <p className="text-sm text-foreground-600 whitespace-nowrap">{siteInfo.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-secondary-500 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">微信公众号</p>
                      <p className="text-sm text-foreground-600 whitespace-nowrap">{siteInfo.wechat}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">办公地址</p>
                      <p className="text-sm text-foreground-600 leading-relaxed">{siteInfo.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqSchema.mainEntity.map((faq, index) => (
                  <details key={index} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200/70 transition-colors">
                      <h3 className="text-base font-medium text-foreground-900 pr-4">{faq.name}</h3>
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.acceptedAnswer.text}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}